import { resolveAssistantRouteFamily } from './route-family-registry';

export const SETTINGS_SPECIALIST_METHOD = 'settings.specialist.review';
export const SETTINGS_SPECIALIST_CAPABILITY_PREFIX = 'settings-specialist:';

const toOptionalText = (value: unknown): string | null => {
  if (typeof value !== 'string') {
    return null;
  }
  const normalized = value.trim();
  return normalized.length > 0 ? normalized : null;
};

export const isSettingsSpecialistCapabilityId = (value: unknown): boolean => {
  const normalized = toOptionalText(value);
  return Boolean(normalized && normalized.startsWith(SETTINGS_SPECIALIST_CAPABILITY_PREFIX));
};

export const hasExplicitSettingsSpecialistBinding = (input: {
  activeCapabilityId?: unknown;
  activeCapabilityMethod?: unknown;
}): boolean => {
  const activeCapabilityMethod = toOptionalText(input.activeCapabilityMethod);
  return (
    isSettingsSpecialistCapabilityId(input.activeCapabilityId)
    || activeCapabilityMethod === SETTINGS_SPECIALIST_METHOD
  );
};

export const isSettingsRouteFamilyPath = (pathname: string | null | undefined): boolean => (
  resolveAssistantRouteFamily(pathname).id === 'settings'
);

export const isSettingsIntentTurn = (input: {
  pathname?: string | null;
  resolvedModule?: unknown;
  activeCapabilityId?: unknown;
  activeCapabilityMethod?: unknown;
  settingsIntent?: boolean | null;
}): boolean => {
  if (input.settingsIntent === true) {
    return true;
  }
  if (isSettingsRouteFamilyPath(input.pathname)) {
    return true;
  }
  if (hasExplicitSettingsSpecialistBinding(input)) {
    return true;
  }
  const resolvedModule = toOptionalText(input.resolvedModule)?.toLowerCase();
  return resolvedModule === 'settings';
};
